import Init from './init'
import General from './general'
import SuperAdmin from './superAdmin'
import Quotation from './quotation'

const state = Object.assign({}, Init.state, General.state, SuperAdmin.state, Quotation.state)
const getters = Object.assign({}, Init.getters, General.getters, SuperAdmin.getters, Quotation.getters)
const actions = Object.assign({}, Init.actions, General.actions, SuperAdmin.actions, Quotation.actions)
const mutations = Object.assign({}, Init.mutations, General.mutations, SuperAdmin.mutations, Quotation.mutations)

export default {
  state,
  getters,
  mutations,
  actions
}
